module.exports = __webpack_public_path__ + "static/img/Brad_Crouch_desktop.7eee301.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brad_Crouch_desktop.jpg
// module id = e5Ml
// module chunks = 0